import { compose, mdsWidget } from 'dojo/_base/declare';
//import template = require("dojo/text!./teams_channel_finder.html");
import FinderBaseV2 from '../../../FinderBase/FinderBaseV2';
import lang from 'dojo/_base/lang';
import StaticTable from '../../../../moreCore/UI/StaticTable/StaticTable';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';


class teams_channel_finder extends compose(FinderBaseV2) {
    //templateString = template;

    private confirmDlg: MdsLax<InstanceType<typeof GenericDialog>> = null;
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupFinderWithCallfunctions(
            "Webtool_API_MS_Teams_Integration_AdminPanel__ImportChannel_Finder_GetConfig",
            "Webtool_API_MS_Teams_Integration_AdminPanel__ImportChannel_Finder_GetResults",
            lang.hitch(this, this._onClick_TableRow) as any,
            lang.hitch(this, this._tableFormatter) as any,
            /*{
                neededUserRole: null,
                callback: lang.hitch(this, this._onClick_CreateNew) as any
            }*/
        );
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    private _onClick_TableRow(row: StaticTable.StaticTableRow<any>) {
        let entity = row.rowGroup.entity;

        //confirm dlg
        if (this.confirmDlg != null) {
            try {
                this.confirmDlg.destroyRecursive();
            } catch { }
        }
        this.confirmDlg = new GenericDialog();
        let dlgTxt: string = this.getTranslation("MsTeamsIntegration_AdminPanel_ConfirmImport") + "<br>";
        dlgTxt += '<span class="italic">' + entity["teamDisplayName"] + " / " + entity["displayName"] + '</span>';
        this.confirmDlg.show(
            dlgTxt,
            this.translate("General_Import"),
            null,
            "fas fa-file-import w3-xxxlarge w3-margin",
            'yesno',
            (selection: number) => {
                if (selection == 2) {
                    this.emit("entitySelected", entity);
                }
            }, null
        );
    }
    private _onClick_CreateNew(ev: Event) {
        this.emit("createNew");
    }
    private _tableFormatter(cell: StaticTable.StaticTableCell<any>): boolean {
        let val = cell.value;
        let container = document.createElement('div');

        container.innerHTML = val + "";
        container.title = val;

        cell.contentnode.innerHTML = "";
        cell.contentnode.appendChild(container);


        return true;
    }
}

export default mdsWidget(teams_channel_finder);
